import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import { Spinner } from 'components/Common/Spinner';
import './printPdfModal.scss';

interface IPrintPdfModalProps {
    closePdfModal: () => void;
    printPdf: () => Promise<void>;
    pdfModalVisible: boolean;
    pdfPrintStatus: IPrintPollStatus;
    resetState: () => void;
}

interface IPrintPdfModalState {
    isProcessing: boolean;
}

export class PrintPdfModal extends React.PureComponent<IPrintPdfModalProps, IPrintPdfModalState> {
    constructor(props: IPrintPdfModalProps) {
        super(props);
        this.state = {
            isProcessing: false
        };

        this.onConfirm = this.onConfirm.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentWillUnmount(): void {
        this.props.resetState();
    }

    render(): React.ReactNode {
        const { pdfModalVisible } = this.props;
        if (!pdfModalVisible) {
            return null;
        }
        return (
            <ConfirmationModal
                className="print-pdf-modal"
                message={this.renderMessage()}
                onCancel={this.onClose}
                onClose={this.onClose}
                onConfirm={this.onConfirm}
                title="Print Employee Pdfs"
                confirmMessage="Yes, print pdfs"
                cancelMessage="No, do not print"
                hideAttentionIcon={true}
                isCancelLink={false}
                isProcessing={this.state.isProcessing}
            />
        );
    }

    renderMessage(): React.ReactNode {
        const { failedFileNames, failedPageIds, fileNames } =  this.props.pdfPrintStatus;
        if (failedFileNames?.length || failedPageIds?.length) {
            return (
                <div className="print-pdf-modal__body">
                    <h3 className="print-pdf-modal__error-text">The download of your pdfs failed. Please try again later.</h3>
                </div>
            );
        } else if (fileNames?.length) {
            return (
                <div className="print-pdf-modal__body">
                    <h3 className="print-pdf-modal__success-text">You have successfully downloaded your pdfs!</h3>
                </div>
            );
        } else if (this.state.isProcessing) {
            return (
                <div className="print-pdf-modal__body">
                    <h3 className="print-pdf-modal__progress-text">We&apos;re processing your request now.</h3>
                    <Spinner size={50} />
                </div>
            );
        }
        return null;
    }

    onClose(): void {
        this.setState({isProcessing: false});
        this.props.resetState();
        this.props.closePdfModal();
    }

    async onConfirm(): Promise<void> {
        this.setState({isProcessing: true});
        await this.props.printPdf();
    }
}